export enum PromptKind {
  RETURN_REVIEW_SYSTEM = "return_review:system",
  RETURN_REVIEW_STORE_POLICY = "return_review:store_policy",

  // main Prompt for return chat ai
  RETURN_CHAT_SYSTEM = "return_chat:system",

  // these are descriptions of the return settings, totals, and flow db objects.
  // these should be paired with a description for each field on the object
  RETURN_SETTINGS_CONTEXT = "return_settings:context",
  RETURN_TOTALS_CONTEXT = "return_totals:context",
  RETURN_FLOW_CONTEXT = "return_flow:context",

  OMS_ADDRESS_CORRECTION = "oms:address_correction",
  OMS_ADDRESS_COMPARISON = "oms:address_comparison",
  OMS_UPS_GHOST_ACCOUNT_ADDRESS = "oms:ups_ghost_account_address",

  // Merchant agent prompts
  SLACK_MESSAGE_CATEGORIZATION = "slack_message_categorization:system",
  RETURNS_MERCHANT_AGENT = "return_chat_v2:system",
  OMS_MERCHANT_AGENT = "oms_merchant_agent:system",
  MARKETING_MERCHANT_AGENT = "marketing_merchant_agent:system",

  // Conversion agent prompts
  CHECKOUT_EXPERIENCE_VALIDATION = "checkout_experience_validation:system",
}

export enum PromptScope {
  USER = "user",
  TEAM = "team",
  DEFAULT = "default",
}

export const allowedAgentEditingEmails = [
  "pj@getredo.com",
  "aaron@getredo.com",
  "tommy.wei@getredo.com",
  "alex.burns@getredo.com",
  "tony@getredo.com",
  "michael@getredo.com",
  "jordan@getredo.com",
  "bryson@getredo.com",
  "logan.orr@getredo.com",
  "bryce@getredo.com",
  "harrison.walker@getredo.com",
  "jared@getredo.com",
  "aaron.drewery@getredo.com",
  "hugh@getredo.com",
  "suz@getredo.com",
  "emry@getredo.com",
  "jacob.olson@getredo.com",
  "jason.lowe@getredo.com",
  "manny@getredo.com",
  "will.schaefermeyer@getredo.com",
  "steven.mitchell@getredo.com",
  "paul@redo.com",
  "dev@getredo.com",
  "alee@redo.com",
  "coleman@redo.com",
  "cameron.walker@redo.com",
  "grant@redo.com",
];

export const allowedAiOpsEmails = [
  "bryson@getredo.com",
  "bryce@getredo.com",
  "jacob.olson@getredo.com",
  "dev@getredo.com",
  "alee@redo.com",
];
